import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { MotifButtonModule, MotifIconModule } from '@ey-xd/ng-motif';

import { IconoirNavArrowDown, IconoirNavArrowUp } from '@ey-xd/motif-icon';

@Component({
  selector: 'app-expand-button',
  standalone: true,
  imports: [MotifIconModule, MotifButtonModule],
  templateUrl: './expand-button.component.html',
  styleUrl: './expand-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandButtonComponent {
  readonly expanded = model<boolean>(false);

  readonly expandLabel = input<string>('View More');
  readonly collapseLabel = input<string>('View Less');
  readonly parentComponentName = input<string>('');

  readonly label = computed(() => (this.expanded() ? this.collapseLabel() : this.expandLabel()));
  readonly icon = computed(() => (this.expanded() ? IconoirNavArrowUp : IconoirNavArrowDown));
  readonly getAriaLabel = computed(() => {
    const label = this.expanded() ? this.collapseLabel() : this.expandLabel();
    return `${label} ${this.parentComponentName()}`;
  });

  public toggleExpanded(): void {
    this.expanded.update(value => !value);
  }
}
